import { render, staticRenderFns } from "./CarlosIVA.vue?vue&type=template&id=216cb18e&scoped=true&"
import script from "./CarlosIVA.vue?vue&type=script&lang=js&"
export * from "./CarlosIVA.vue?vue&type=script&lang=js&"
import style0 from "./CarlosIVA.vue?vue&type=style&index=0&id=216cb18e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216cb18e",
  null
  
)

export default component.exports